import { resolveI18n } from '../../../utils/translation'

import { BUTTON_ARROW_CONTENT_ICON_PLACEMENT_BEFORE } from './ButtonArrow.constants'

export function getButtonArrowTooltipKey({
  closeTooltipText = 'Select.CloseTooltipKey',
  isOpen,
  openTooltipText = 'Select.OpenTooltipKey',
  t,
}) {
  return resolveI18n({
    t,
    translationItem: isOpen ? closeTooltipText : openTooltipText,
  })
}

export function isIconPlacementBeforeContent(placement) {
  return placement === BUTTON_ARROW_CONTENT_ICON_PLACEMENT_BEFORE
}
